import axios from 'axios';
import cookieService from './cookieService';

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL || '/api/v1',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    timeout: 10000,
});

apiClient.interceptors.request.use(
    (config) => {
        // Prefer token from cookie (the master source for 3-day session)
        let token = cookieService.getCookie('token');

        // If cookie is empty but localStorage has token, cookie might have expired
        if (!token && localStorage.getItem('token')) {
            console.log("Session cookie expired (3 days). Auto-logging out...");
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            window.location.href = '/login';
            return config;
        }

        // Fallback or verify with localStorage
        if (!token) {
            token = localStorage.getItem('token');
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            cookieService.eraseCookie('token');
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
